<template>
  <div id="bucket" :style="`margin-top:${height}px`">
    <router-view></router-view>
  </div>
</template>

<script>
import { SafeArea } from 'capacitor-plugin-safe-area';

export default {
  name: "App",
  components: {
  },
  data() {
    return {
      height: 0
    }
  },
  mounted() {
    SafeArea.getStatusBarHeight()
    .then(({ statusBarHeight }) => {
      this.height = statusBarHeight;
    });
  }
};
</script>

<style>
body { 
  padding-top: env(safe-area-inset-top);
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
p {
  color: #5e5e5e;
}
#bucket {
  max-width: 1200px;
  margin: auto;
}
</style>
